import { Module } from '@nestjs/common';
import { PrismaService } from '@cart/api-data-access';
import { AuthModule } from '../auth/auth.module';
import { WishlistController } from './wishlist.controller';
import { PrismaWishlistRepository, WishlistRepository } from './wishlist.repository';
import { WishlistService } from './wishlist.service';

@Module({
  imports: [AuthModule],
  controllers: [WishlistController],
  providers: [
    WishlistService,
    PrismaService,
    {
      provide: WishlistRepository,
      useClass: PrismaWishlistRepository,
    },
  ],
})
export class WishlistModule {}
